<template>
  <li>
    <component
      :is="isType"
      :class="`tw-block tw-whitespace-nowrap tw-rounded-2xl tw-bg-black/30 tw-px-4 tw-py-3 tw-text-sm tw-font-bold tw-uppercase tw-tracking-wider tw-text-gp-mouse/80 tw-transition-colors hover:tw-text-white ${
        disabled ? ' tw-cursor-not-allowed' : ''
      }`"
      :to="to"
      :title="hoverTitle"
      active-class="!tw-text-white"
      exact-active-class="!tw-text-white"
    >
      {{ title }}
      <slot />
    </component>
  </li>
</template>

<script lang="ts">
import { RouterLink } from 'vue-router';

export default {
  computed: {
    isType() {
      return this.disabled ? 'span' : RouterLink;
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    hoverTitle: {
      type: String,
      default: '',
    },
    active: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object || String,
      default: null,
    },
  },

  setup() {},
};
</script>

<style scoped>
a.nav-link.is-active,
a.nav-link.router-link-active {
  background: rgba(0, 0, 0, 0.3);
  color: #eee;
}

a.nav-link.disabled {
  color: rgba(255, 255, 255, 0.5);
}
</style>
